import { makeUseDocumentPath, makeUseSelector } from '@common/store-tools';
import { ConnectCollections } from '@contracts/connect';
import { ConnectReduxState } from './reduxStore';

export const useDocumentPath = makeUseDocumentPath<ConnectCollections>();
export const useSelector = makeUseSelector<ConnectReduxState>();
